import { APP_ROUTES, useCurrentSignatureRequestKey } from '~~core';

export function useSignupShortcut() {
  const { signatureRequestKey } = useCurrentSignatureRequestKey();

  const signupWithShortcut = computed(() => `${APP_ROUTES.signup}?key=${signatureRequestKey.value}&signer_area_shortcut=true`);

  return {
    signupWithShortcut,
  };
}
